import Vue from 'vue'

const instance = new Vue()
const defaults = {
  duration: 3
}

class Mensajes {
  static customMessage (type, config) {
    let conf = Object.assign({}, defaults, config)
    instance.$notification[type](conf)
  }

  static success (titulo, mensaje) {
    Mensajes.customMessage('success', {
      message: titulo,
      description: (h) => {
        return h('div', {
          domProps: {
            innerHTML: mensaje
          }
        })
      }
    })
  }

  static error (titulo, mensaje) {
    Mensajes.customMessage('error', {
      message: titulo,
      description: (h) => {
        return h('div', {
          domProps: {
            innerHTML: mensaje
          }
        })
      }
    })
  }

  static info (titulo, mensaje) {
    Mensajes.customMessage('info', {
      message: titulo,
      description: (h) => {
        return h('div', {
          domProps: {
            innerHTML: mensaje
          }
        })
      }
    })
  }

  static warning (titulo, mensaje) {
    Mensajes.customMessage('warning', {
      message: titulo,
      description: (h) => {
        return h('div', {
          domProps: {
            innerHTML: mensaje
          }
        })
      }
    })
  }
}

export default Mensajes



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/Util/Mensajes.js